// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"441e1138","308":"b1b6385f","450":"9686dbca","491":"b4b1637a"}[chunkId] + ".chunk.css";
};